import React from 'react';
import { Checkbox, Select } from 'antd';
import PropTypes from 'prop-types';
import Flex from '../../../shared/components/basic/Flex';
import Text from '../../../shared/components/basic/Text';
import GraduacionCheckboxs from './GraduacionCheckboxs';
import GraduacionInputs from './GraduacionInputs';
import { Box } from '../../../shared/components';
import SelectBorderless from "../../../shared/components/dataEntry/SelectBorderless";

export default function GraduacionBar({
  initialValues,
  onOjoCheckboxChange,
  onGraduacionChange,
  setSeleccionPasillo,
  getLentesListRequest,
  setFueraDeNorma,
  vision,
  permisos,
  ordenGraduacion,
  modo,
  fueraDeNorma,
}) {
  const { derecho, izquierdo } = initialValues;
  const derechoLabel = (derecho) ? derecho.label : null;
  const izquierdoLabel = (izquierdo) ? izquierdo.label : null;
  const labelGraduacion = (modo === 'consulta') ? 'Graduación: ' : `Graduación de ${vision}:`;
  const permiteFuerdaDeNorma = permisos?.configuracion?.permitir_consultar_lentes_fuera_norma === 'S';
  const onSelectFueraDeNorma = (value) => {
    setFueraDeNorma(value !== '1');
  };

  return (
    <Flex alignItems={modo === 'consulta' ? 'center' : 'baseline'}>
      {!permiteFuerdaDeNorma && (modo === 'consulta' || derechoLabel || izquierdoLabel) && (<Text mr={8}>{labelGraduacion}</Text>)}
      {permiteFuerdaDeNorma && (
        <Box mr="8px">
          <SelectBorderless dropdownMatchSelectWidth={false} defaultValue="1" value={fueraDeNorma ? '2' : '1'} onSelect={value => onSelectFueraDeNorma(value)}>
            <Select.Option value="1">Graduación</Select.Option>
            <Select.Option value="2">Todas las lentes RX</Select.Option>
          </SelectBorderless>
        </Box>
      )}
      {permiteFuerdaDeNorma && modo !== 'consulta' && (
        <Text mr={8}>{labelGraduacion}</Text>
      )}
      {modo === 'consulta'
        && (
        <GraduacionInputs
          graduacion={initialValues}
          onGraduacionChange={onGraduacionChange}
          setSeleccionPasillo={setSeleccionPasillo}
          getLentesListRequest={() => {}}
          ordenGraduacion={ordenGraduacion}
        />
        )}
      {modo !== 'consulta'
        && (
        <GraduacionCheckboxs
          vision={vision}
          permisos={permisos}
          graduacion={initialValues}
          labels={{ derechoLabel, izquierdoLabel }}
          onOjoCheckboxChange={onOjoCheckboxChange}
          ordenGraduacion={ordenGraduacion}
        />
        )}
    </Flex>

  );
}

GraduacionBar.propTypes = {
  initialValues: PropTypes.shape({
    derecho: PropTypes.shape({
      isSelected: PropTypes.bool, label: PropTypes.string, visible: PropTypes.bool,
    }).isRequired,
    izquierdo: PropTypes.shape({
      isSelected: PropTypes.bool, label: PropTypes.string, visible: PropTypes.bool,
    }).isRequired,
  }).isRequired,
  onOjoCheckboxChange: PropTypes.func,
  onGraduacionChange: PropTypes.func,
  getLentesListRequest: PropTypes.func,
  setSeleccionPasillo: PropTypes.func,
  vision: PropTypes.string.isRequired,
  modo: PropTypes.string,
  ordenGraduacion: PropTypes.string,
};
GraduacionBar.defaultProps = {
  onOjoCheckboxChange: () => {},
  onGraduacionChange: () => {},
  getLentesListRequest: () => {},
  setSeleccionPasillo: () => {},
  modo: 'consulta',
  ordenGraduacion: null,
};
